export const GET_DELETE_DATA = 'getDeleteData'
export const INNOVATION_FIELD_INPUT = 'innovationFieldInput'
export const INNOVATION_FIELD_ID = 'innovationFieldId'
export const SHOW_DELETE_DIALOG = 'showDeleteDialog'
export const SHOW_EDIT_DIALOG = 'showEditDialog'
export const GET_CREATED_NEW = 'getCreatedNew'
